import {colors} from '@commercial-helios/ui'
import {tokens} from '@pleo-io/telescope'
import React from 'react'
import styled from 'styled-components'

import Button from '@helios/shared/components/button'
import {Text} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

export const bgColors = {
    white: colors.background.default,
    grey: colors.background.muted,
    yellow: colors.background.yellow,
    pink: colors.background.pink,
}

export type BgColor = keyof typeof bgColors
export type Direction = 'left' | 'right'

export interface AdProps {
    headline: string
    description: string
    direction?: Direction
    bgColor?: BgColor
    Image?: React.ComponentType<any>
    CTA?: React.ComponentType<any>
}

export const Ad = ({
    headline,
    description,
    direction = 'left',
    bgColor = 'white',
    Image,
    CTA,
}: AdProps) => (
    <Wrapper $bgColor={bgColor}>
        {Image && <StyledImage as={Image} $direction={direction} width={450} />}

        <Content>
            <CopyWrapper>
                <Text variant="title-base">{headline}</Text>

                <Text variant="paragraph-large" color="muted">
                    {description}
                </Text>
            </CopyWrapper>

            {CTA && <Button as={CTA} />}
        </Content>
    </Wrapper>
)

const MOBILE_BREAKPOINT = 'xs'

type WrapperProps = {
    $bgColor: BgColor
}

type StyledImageProps = {
    $direction: AdProps['direction']
}

const Wrapper = styled.div<WrapperProps>`
    background-color: ${({$bgColor}) => bgColors[$bgColor]};

    ${mq.min(MOBILE_BREAKPOINT)} {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
`

const StyledImage = styled.img<StyledImageProps>`
    aspect-ratio: 1/1;
    width: 100%;
    object-fit: cover;
    object-position: center;

    ${mq.min(MOBILE_BREAKPOINT)} {
        grid-column-start: ${({$direction}) => ($direction === 'left' ? '1' : '2')};
        grid-row: 1;
        align-self: center;
    }
`

const Content = styled.div`
    display: grid;
    grid-gap: ${tokens.spacing20};
    place-content: center start;
    padding: ${tokens.spacing28} ${tokens.spacing24};

    ${mq.min(MOBILE_BREAKPOINT)} {
        padding: ${tokens.spacing28} ${tokens.spacing40};
        grid-gap: ${tokens.spacing40};
        justify-items: start;
    }
`

const CopyWrapper = styled.div`
    display: grid;
    grid-gap: ${tokens.spacing8};
`
